<template>
  <div class="form-body">
    <div class="row">
      <div class="form-holder">
        <div class="form-content" style="padding: 0px;">
          <div class="form-items">
            <!-- <span class="logo" v-html="logos"></span> -->

            <div class="row mt-5"></div>
            <!-- <h3>Welcome to Screenit</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer placerat mi fringilla mauris ullamcorper</p> -->
            <div class="container">
              <form
                class="register-form"
                novalidate
                style="background-color: #ffffff;padding: 20px;"
              >
                <div>
                  <div class="form-row">
                    <h3 class="float-left mb-0 ml-3">Interviewer Details</h3>
                  </div>
                  <hr />
                  <div class="form-row">
                    <div class="form-group">
                      <b-form-input
                        type="text"
                        placeholder="First Name*"
                        v-model="form.firstName"
                        :class="{ 'is-invalid': submitted && $v.form.firstName.$error }"
                      />
                      <div
                  v-if="submitted && $v.form.firstName.$error"
                  class="invalid-feedback" style="color:red; font-size:12px;text-align:left;"
                >

                  <span v-if="!$v.form.firstName.required"
                    >First name is required</span
                  >
                  <span v-if="$v.form.firstName.required && !$v.form.firstName.minLength"
                    >First name must be at least 3 characters</span
                  >
                </div>
                    </div>
                    <div class="form-group">
                      <input
                        type="text"
                        placeholder="Last Name*"
                        v-model="form.lastName"
                        :class="{ 'is-invalid': submitted && $v.form.lastName.$error }"
                      />
                      <div v-if="submitted && $v.form.lastName.$error"
                  class="invalid-feedback"  style="color:red; font-size:12px;text-align:left;"
                >
                  <span v-if="!$v.form.lastName.required"
                    >Last name is required</span
                  >
                  <!-- <span v-if="$v.form.lastName.required && !$v.form.lastName.minLength"
                    >Last name must be at least 3 characters</span
                  > -->
                </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group">
                      <div class="form-select">
                        <select
                          id="orgtype"
                          v-model="form.organizationStatus"
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.organizationStatus.$error }"
                        >
                          <option value="" class="text" disabled
                            >Select Role*</option
                          >
                          <option>Interviewer</option>
                          <option>Candidate</option>
                        </select>
                        <span class="select-icon"
                          ><i class="fa fa-chevron-down"></i
                        ></span>
                      </div>
                      <div
                  v-if="submitted && $v.form.organizationStatus.$error"
                  class="invalid-feedback" style="color:red;text-align: left "
                >
                  <span v-if="!$v.form.organizationStatus.required"  style="color:red; font-size:12px;"
                    >*select your role</span
                  >
                </div>
                    </div>
                    <div class="form-group">
                      <input style="background:lightgrey"
                        type="email"
                        placeholder="Email*"
                        v-model="form.user_email"
                        readonly
                      />
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group">
                      <vue-tel-input
                        class="form-control"
                        placeholder="Mobile Number"
                        @onInput="onInput"
                        v-bind:class="{ 'is-invalid': !isValiedmobileNumber }"
                      ></vue-tel-input>
                      <div v-if="$v.form.mobile_number.$error">
                        <p
                          v-if="!$v.form.mobile_number.required"
                          class="login-alert-msg error-content"
                        >
                          * Enter your mobile number
                        </p>
                        <p
                          v-if="$v.form.mobile_number.required && !$v.form.mobile_number.minLength"
                          class="login-alert-msg error-content"
                        >
                          * Enter a valid mobile number
                        </p>
                      </div>
                    </div>
                    <div class="form-group">
                      <b-form-input
                      :type="passwordFieldType"
                        placeholder="Password*"
                        autocomplete="off"
                        minlength="8"
                        v-model="form.user_password"
                        :class="{ 'is-invalid': submitted && $v.form.user_password.$error }"
                      />
                      <span class="uil uil-eye form-control-feedback" style="right: 12px;"
                      v-if="passwordFieldType == 'text'"
                      @click="switchVisibility"></span>
                    <span id="visibility" class="uil uil-eye-slash form-control-feedback"
                      v-if="passwordFieldType == 'password'"
                      @click="switchVisibility"></span>
                      <p style="font-size: 11px" class="error-msg" v-if="$v.form.user_password.required && !chkState('user_password')"><span>* Must have 8 characters with 1 upper case letter, 1 number & 1 special character</span></p>
                    <div v-if="$v.form.user_password.$error" style="text-align: left">
                      <span v-if="!$v.form.user_password.required" class="login-alert-msg error-content">* Enter the password</span>
                    </div>
                    </div>
                  </div>
                  <div class="form-col">
                    <div class="form-group terms">
                      <input v-model="termscondition" type="checkbox" style="width:4%" /><label
                        >Accept
                        <a href="https://screenit.io/terms&conditions.html" target="_blank">Terms and Condition and Privacy policy</a
                        ></label
                      >
                    </div>
                    <span class="error-msg" v-if="!termscondition && submitted2">* Please accept the terms & condition to proceed</span>
                  </div>
                  <div class="form-col mt-2">
                    <div class="form-group signupbtn">
                      <button
                        to="/InterviewerExperience"
                        type="button"
                        class="btn btn-success btn-md pull-right"
                        v-on:click.prevent="onSubmitProfile"
                      >
                        Sign Up
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin, Vuelidate } from 'vuelidate'
import { required, maxLength, minLength, alpha } from 'vuelidate/lib/validators'
import axios from 'axios'
import Vue from 'vue'
import { BaseURL } from '../../../shared/classes'
import { VueTelInput } from 'vue-tel-input'
Vue.use(Vuelidate, axios)

export default {
  name: 'userprofile',
  components: {
    VueTelInput
  },
  data () {
    return {
      form: {
        firstName: '',
        lastName: '',
        organizationStatus: '',
        user_email: localStorage.getItem('user_email'),
        mobile_number: '',
        user_password: ''
      },
      submitted: false,
      submitted2: false,
      termscondition: false,
      roleList: '',
      isValiedmobileNumber: true,
      signup: '',
      id: '',
      token: '',
      passwordFieldType: 'password',
      condition: '',
      organization_name: ''
    }
  },
  created () {
    localStorage.getItem('user_email')
    // localStorage.getItem('token')
    localStorage.getItem('user_id')
    this.submitted = true
    // return this.$v.$touch()
  },
  computed: {
    formStr () {
      return JSON.stringify(this.form, null, 4)
    },
    isValid () {
      return !this.$v.form.$anyError
    },
    isDirty () {
      return this.$v.form.$anyDirty
    },
    invCheck () {
      return 'You must accept before submitting'
    }
  },
  mixins: [validationMixin],
  validations: {
    form: {
      firstName: {
        required,
        alpha,
        minLegth: minLength(3)
      },
      lastName: { required },
      // emailId: {},
      mobile_number: {
        required,
        maxLength: maxLength(10)
      },
      user_password: {
        required,
        minLength: minLength(8),
        strongPassword (userpassword) {
          return (
            /[a-z]/.test(userpassword) && // checks for a-z
            /[0-9]/.test(userpassword) && // checks for 0-9
            /\W|_/.test(userpassword) && // checks for special char
            userpassword.length >= 8
          )
        }
      },
      organizationStatus: {
        required
      }
    }
  },
  methods: {
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some(child => {
        focused = this.findFirstError(child)
        return focused
      })
      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    chkState (val) {
      const field = this.$v.form[val]
      return !field.$dirty || !field.$invalid
    },
    switchVisibility () {
      this.passwordFieldType =
      this.passwordFieldType === 'password' ? 'text' : 'password'
    },
    onInput ({ number, isValid, country }) {
      console.log(this.form)
      console.log(isValid)
      console.log(country)
      this.isValiedmobileNumber = true
      this.form.mobile_number_country_code = country.dialCode
      this.form.mobile_number = number.significant
    },
    toggleShow () {
      this.show = !this.show
    },
    termsandCondition () {
      axios
        .get(BaseURL + '/dashboard/get_static_page_link')
        .then(response => {
          this.condition = response.data.page_link[1].page_link
          console.log(this.condition)
        })
    },
    onSubmitProfile () {
      this.submitted = true
      console.log(this.termscondition)
      if (this.validate()) {
        this.submitted2 = true
        if (!this.termscondition) {
          return false
        }
        this.$nextTick(() => {
          if (this.form.organizationStatus === 'Interviewer') {
            this.form.organization_name = 'individual'
          } else {
            this.form.organization_name = 'Candidate'
          }
          const data = {
            user_email: localStorage.getItem('user_email'),
            mobile_number: this.form.mobile_number,
            firstName: this.form.firstName,
            lastName: this.form.lastName,
            organizationStatus: this.form.organization_name,
            user_password: this.form.user_password,
            mobile_number_country_code: this.form.mobile_number_country_code
          }
          axios.post(BaseURL + '/email/create/user/using/email/mobile', { formData: data }).then(response => {
            this.signup = response.data.message
            console.log(this.signup)
            // this.user_email = ''
            if (this.signup === 'Success') {
              this.token = response.data.token
              this.$router.push('/InterviewerExperience')
              this.id = response.data.userdetail._id
              localStorage.setItem('_id', this.id)
              localStorage.setItem('token', this.token)
              localStorage.setItem('firstName', this.form.firstName)
              console.log(this.id)
            } else {
              alert(response.data.message)
            }
          }).catch(e => {
            console.log(e)
          })
        })
        this.$v.$touch()
      } else {
        console.log('validation faild................')
      }
    }
  }
}
</script>

<style scoped>
#visibility{
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
  right: 12px;
}
.signup {
  display: flex;
  justify-content: center;
}
.terms {
  width: 100%;
  flex-direction: row;
  display: flex;
  justify-content: flex-end;
  /* align-items: baseline; */
}
.signupbtn {
  display: flex;
  justify-content: center;
}

.form-content .form-items {
  border: none !important;
  box-shadow: none !important;
}

/* .form-content .form-items {
    background-color: #ffffff !important;
} */
.newDesign {
  width: 44%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto !important;
}
.pwd_info {
  float: left;
  font-size: 12px;
  padding-bottom: 11px;
  color: red;
  margin-top: -10px;
}

.pwd_info_float_right {
  float: right;
  font-size: 12px;
  padding-bottom: 11px;
  color: #5bad2b;
  /* cursor: pointer; */
  margin-top: -10px;
}

.pading_____zero {
  margin-bottom: 2px !important;
}

.was-validated .form-control:valid,
.form-control.is-valid {
  background-image: none;
}

.was-validated .form-control:invalid,
.form-control.is-invalid {
  background-image: none;
}

.input-group.form-control.is-valid {
  background-image: none;
  padding-right: calc(1.5em + 0.75rem);
}
.input-group.form-control.is-invalid {
  background-image: none;
  padding-right: calc(1.5em + 0.75rem);
}

input.form-control.is-valid {
  background-image: none !important;
}

.form-holder {
  margin-left: 0px;
}

.login-policy-footer {
  width: 31%;
}

.progressbar {
  height: 5px !important;
  background: #e6e6e6;
}

ul {
  padding: 0px;
}

span.field-icon {
  position: absolute;
  display: inline-block;
  cursor: pointer;
  right: 0.5rem;
  top: 0.7rem;
  z-index: 2;
  margin-top: 7px;
}

.register____user__type {
  color: #000000;
  margin-bottom: 17px !important;
  cursor: pointer;
}

.progress_____round {
  border: 1px solid #5bad2b;
  padding: 9px;
  border-radius: 21px;
  width: 40px;
  height: 40px;
  color: #5bad2b;
  font-weight: bold;
}

.progress_____round____hidden {
  border: 1px solid #bbb4b4;
  padding: 9px;
  border-radius: 21px;
  width: 40px;
  height: 40px;
  color: #bbb4b4;
  font-weight: bold;
}

.form-content .form-items {
  max-width: 70%;
  padding: 25px;
  border: 1px solid #ffffff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.4);
}

svg {
  width: 100%;
}

.content-title {
  padding: 35px 0px 35px 105px;
}

.content-title-header {
  font-size: 22px;
  color: #000000;
}

.content-title-sub-header {
  color: #2f2f2f;
  font-size: 15px;
}

display-flex,
.signup-content,
.form-row,
.form-radio,
.select-icon,
.select-icon i {
  display: flex;
  display: -webkit-flex;
}

/* @extend list-type-ulli; */
list-type-ulli {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.file-loading {
  width: 50%;
}

img {
  max-width: 254px;
  height: auto;
}

figure {
  margin: 0;
}

.clear {
  clear: both;
}

.container {
  width: 100%;
  position: relative;
  margin: 0 auto;
  background: #f5f5f5;
}

.signup-img {
  width: 30%;
}

.signup-form {
  width: 70%;
}

.form-row {
  margin: 0 -15px;
}

.form-row .form-group {
  width: 50%;
  padding: 0 15px;
}

.form-group {
  margin-bottom: 15px !important;
  position: relative;
}
.form-items {
  margin-top: 2%;
}

label {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 2px;
  display: block;
}

.form-radio {
  margin-bottom: 18px;
}

.form-radio input {
  width: auto;
  display: inline-block;
}

.radio-label {
  padding-right: 72px;
}

.form-radio-item {
  position: relative;
  margin-right: 45px;
}

.form-radio-item label {
  font-weight: 400;
  font-size: 13px;
  padding-left: 25px;
  position: relative;
  z-index: 9;
  display: block;
  cursor: pointer;
}

.check {
  display: inline-block;
  position: absolute;
  border: 1px solid #ebebeb;
  border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  -o-border-radius: 50%;
  -ms-border-radius: 50%;
  height: 13px;
  width: 13px;
  top: 4px;
  left: 0px;
  z-index: 5;
  transition: border 0.25s linear;
  -webkit-transition: border 0.25s linear;
}

.check:before {
  position: absolute;
  display: block;
  content: "";
  width: 9px;
  height: 9px;
  border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  -o-border-radius: 50%;
  -ms-border-radius: 50%;
  top: 2px;
  left: 2px;
  margin: auto;
  transition: background 0.25s linear;
  -webkit-transition: background 0.25s linear;
}

input[type="radio"] {
  position: absolute;
  visibility: hidden;
}

input[type="radio"]:checked ~ .check {
  border: 1px solid #4dbd74;
}

input[type="radio"]:checked ~ .check::before {
  background: #4dbd74;
}

.form-select {
  position: relative;
}

select {
  appearance: none !important;
  -moz-appearance: none !important;
  -webkit-appearance: none !important;
  -o-appearance: none !important;
  -ms-appearance: none !important;
  position: relative;
  background: 0 0;
  z-index: 10;
  cursor: pointer;
}

.select-icon {
  z-index: 999;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  justify-content: center;
  -moz-justify-content: center;
  -webkit-justify-content: center;
  -o-justify-content: center;
  -ms-justify-content: center;
  align-items: center;
  -moz-align-items: center;
  -webkit-align-items: center;
  -o-align-items: center;
  -ms-align-items: center;
}

.select-icon i {
  justify-content: center;
  -moz-justify-content: center;
  -webkit-justify-content: center;
  -o-justify-content: center;
  -ms-justify-content: center;
  align-items: center;
  -moz-align-items: center;
  -webkit-align-items: center;
  -o-align-items: center;
  -ms-align-items: center;
  width: 40px;
  height: 20px;
  font-size: 18px;
  color: #999;
}

.form-submit {
  text-align: right;
  padding-top: 27px;
}

@media screen and (max-width: 1024px) {
  /* .register-form {
    padding: 0px 40px 50px 0px;
  } */

  .signup-img,
  .signup-form {
    width: 100%;
  }

  .content-title {
    padding: 35px 0px 35px 125px;
  }

  .image-design {
    height: 254px;
  }

  .container {
    width: 100%;
    max-width: 100% !important;
  }
}

@media screen and (max-width: 992px) {
  .container {
    width: 100%;
    max-width: 100% !important;
  }

  .signup-img {
    width: 30%;
  }

  .signup-form {
    width: 70%;
  }

  .image-width {
    width: 100%;
    height: 100%;
  }

  .content-title {
    padding: 35px 0px 35px 0px;
  }
}

@media screen and (max-width: 800px) {
  .form-content .form-items {
    max-width: 100%;
    padding: 15px;
    border: none;
    box-shadow: none;
  }

  .signup-content {
    flex-direction: column;
    -moz-flex-direction: column;
    -webkit-flex-direction: column;
    -o-flex-direction: column;
    -ms-flex-direction: column;
  }

  .signup-img,
  .signup-form {
    width: 100%;
  }

  .content-title {
    padding: 35px 0px 35px 0px;
  }

  .image-design {
    height: 354px;
  }

  .content-title {
    padding: 35px 0px 35px 0px;
    text-align: center;
  }
}

@media screen and (max-width: 768px) {
  .signup-img,
  .signup-form {
    width: 100%;
  }

  .form-content .form-items {
    max-width: 100% !important;
    padding: 15px !important;
    border: none !important;
    box-shadow: none !important;
  }
}

@media screen and (max-width: 575px) {
  .form-row {
    flex-direction: column;
    -moz-flex-direction: column;
    -webkit-flex-direction: column;
    -o-flex-direction: column;
    -ms-flex-direction: column;
    margin: 0px;
  }

  .form-row .form-group {
    width: 100%;
    padding: 0px;
  }

  .radio-label {
    padding-right: 22px;
  }

  .form-radio-item {
    margin-right: 25px;
  }
}

@media screen and (max-width: 480px) {
  .form-radio {
    flex-direction: column;
    -moz-flex-direction: column;
    -webkit-flex-direction: column;
    -o-flex-direction: column;
    -ms-flex-direction: column;
  }
}

.image-design {
  margin-left: auto;
  margin-right: auto;
  display: block;
}

.was-validated .form-control:valid,
.form-control.is-valid {
  background-image: none;
}

.was-validated .form-control:invalid,
.form-control.is-invalid {
  background-image: none;
}
.form-content {
  width: auto;
}
.form-row {
  margin: inherit;
}
.form-content h3 {
  margin-bottom: auto;
  margin-top: auto;
}
.mt-5 {
  margin-top: 35px;
}
.profile-image-center img {
  max-width: 100px;
  height: 100px;
}
.btn {
  width: 30%;
  height: 35px;
}
select.is-invalid {
  border: 1px solid red;
}
.vue-image-crop-upload
  .vicp-wrap
  .vicp-step2
  .vicp-crop
  .vicp-crop-left
  .vicp-range
  input[type="range"] {
  /* display: block; */
  padding-top: 10px !important;
}
.grey_color {
  color: #acacac !important;
}
.edit-icon {
  position: absolute;
  top: 65%;
  right: 0%;
  background-color: #efefef;
  padding: 7px;
  border-radius: 14px;
  color: black;
  border: 1px solid #ccc;
}
</style>
